export const navigate = (path, newTab = false) => {
  if (newTab) {
    window.open(path, '_blank');
  } else {
    window.location.href = path;
  }
};
export const getDeferred = () => {
  const deferred = {};
  deferred.promise = new Promise((resolve, reject) => {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  return deferred;
};
export function waitForBoolean(condition, intervalMs = 50, timeoutMs = 10000) {
  const conditionName = condition.name || 'anonymous function';
  const deferred = getDeferred();
  let interval = NaN;
  let timeout = NaN;
  interval = setInterval(() => {
    if (condition()) {
      clearInterval(interval);
      clearTimeout(timeout);
      return deferred.resolve(true);
    }
  }, intervalMs);
  timeout = setTimeout(() => {
    clearInterval(interval);
    return deferred.reject(new Error(`Failed to verify '${conditionName}' within ${timeoutMs} milliseconds.`));
  }, timeoutMs);
  return deferred.promise;
}